export default __webpack_public_path__ + "static/media/mech-services.7f1602ec.jpg";